<template>
    <div class="content-wrapper leading-5 text-sm font-normal text-gray-950">
        <div class="border-b-2 px-8 pt-6">
            <div class="w-60 mb-5 flex flex-col items-start">
                <div class="report-label main-text-color">
                    {{ $t('report.schedule.name') }}
                </div>
                <el-input
                    v-model="model.ReportTriggerName"
                    :placeholder="$t('report.schedule.name')"
                    type="text"
                />
            </div>
        </div>
        <div class="flex justify-between mb-2 px-8 pt-4">
            <div class="flex">
                <div
                    class="flex flex-col w-38 items-start trigger"
                >
                    <span class="mb-2 main-text-color">
                        {{ $t('report.frequency') }}:
                    </span>
                    <base-select
                        v-model="model.ReportTriggerTypeID"
                        labelKey="ReportTriggerTypeName"
                        valueKey="ReportTriggerTypeID"
                        :multiple="false"
                        :filterable="false"
                        :data="reportTriggerTypeList"
                        @change="onChangeFrequency"
                    >
                        <template v-slot:prefix>
                            <component
                                class="text-primary w-4 h-4 mt-1-5"
                                :class="$rtl.isRTL ? 'mr-1' : 'ml-1'"
                                :is="model.icon"
                            />
                        </template>
                    </base-select>
                </div>
                <div class="transition flex flex-wrap items-start flex-row" v-if="showTriggerComponents">
                    <component
                        v-for="(component, index) in activeTrigger"
                        :is="getComponentName(component)"
                        :key="index"
                        @change="onChange"
                        class="trigger-component"
                        v-bind="component"
                        :label="component.TriggerParameterTag"
                        :isClickedOnNextBtn="clickedOnNextBtn"
                        :modelData="scheduleData.ScheduleData"
                    />
                </div>
            </div>
        </div>
        <div class="pt-4 px-8 flex items-center w-full h-full">
            <span class="icon-logo-voicenter">
                <img :src="getLogo"
                    alt="Logo"
                    class="opacity-10 max-h-52 object-cover"
                >
            </span>
        </div>
        <portal to="next-button">
            <base-button
                fixed-width="w-37"
                type="primary"
                @click="goNext"
            >
                <div class="flex items-center">
                    <span class="mx-1 text-base font-bold">
                        {{ $t('general.next') }}
                    </span>
                    <IconDirLeft v-if="$rtl.isRTL" class="mx-1" />
                    <IconDirRight v-else class="mx-1" />
                </div>
            </base-button>
        </portal>
    </div>
</template>
<script>

    export default {
    props: {
        reportId: {
            type: [Number, String],
            default: ''
        },
        scheduleData: {
            type: Object,
            default: () => ({})
        },
        reportData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        TimeRange: () => import('@/modules/common/components/form/TimeRange'),
        Interval: () => import('@/modules/common/components/form/Interval'),
        Conditions: () => import('@/modules/reports/components/schedule/components/Conditions'),
        Date: () => import('@/components/Widgets/BaseDate'),
        DayOfTheWeek: () => import('@/modules/common/components/form/DayOfTheWeek'),
        InputText: () => import('@/modules/common/components/form/InputText'),
        InputNumber: () => import('@/modules/common/components/form/InputNumber'),
        UserSelect: () => import('@/modules/common/components/form/UserSelect'),
        AccountSelect: () => import('@/modules/common/components/form/AccountSelect'),
        DayOfMonth: () => import('@/modules/common/components/form/DayOfMonth')
    },
    data () {
        return {
            model: {
                ReportTriggerTypeID: null,
                ReportTriggerName: null
            },
            showTriggerComponents: true,
            clickedOnNextBtn: false
        }
    },
    computed: {
        reportTriggerTypeList() {
            return this.$store.getters['reportTrigger/getConfData'].ReportTriggerTypeList
        },
        activeTrigger () {
            if (!this.model.ReportTriggerTypeID) {
                return
            }
            const reportTriggerParameters = this.reportTriggerTypeList.find(el => el.ReportTriggerTypeID === this.model.ReportTriggerTypeID).ReportTriggerParameters
            return reportTriggerParameters.sort((a, b) => a.ParameterOrder - b.ParameterOrder)
        },
        getLogo() {
            return this.$store.getters['layout/getLogo']('activeLayout')
        },
    },
    methods: {
        async onChangeFrequency (val) {
            const copyOfModel = JSON.parse(JSON.stringify(this.model))
            this.model = {
                ReportTriggerTypeID: null,
                ReportTriggerName: null
            }
            this.model.ReportTriggerTypeID = val
            this.model.ReportTriggerName = copyOfModel.ReportTriggerName
            this.showTriggerComponents = false
            this.$nextTick(() => {
                this.showTriggerComponents = true
            })

            const scheduleData = this.scheduleData.ScheduleData
            for (const key in scheduleData) {
                if (Object.hasOwnProperty.call(scheduleData, key)) {
                    scheduleData[key] = null
                    
                }
            }

            this.clickedOnNextBtn = false
        },
        goNext() {
            this.clickedOnNextBtn = true
            const isScheduleFieldsNotEmpty = () => {
                const haveTriggerComponent = Object.keys(this.model).filter(field => !field.includes('ReportTrigger'))
                const allFieldsValid = Object.entries(this.model)
                    .filter(field => !field[0].includes('ReportTrigger'))
                    .every(field => field[1])

                return haveTriggerComponent.length === this.activeTrigger.length && allFieldsValid
            }

            if (!isScheduleFieldsNotEmpty()) {
                return
            }

            const objToEmit = {
                nextStep: true
            }
            const reportTrigger = this.reportTriggerTypeList.find(el => el.ReportTriggerTypeID === this.model.ReportTriggerTypeID)

            const data = {
                ReportTriggerTypeID: this.model.ReportTriggerTypeID,
                ReportTriggerName: this.model.ReportTriggerName,
                ReportID: Number(this.$route.params.id) || this.reportId,
                ReportTriggerTypeName: reportTrigger.ReportTriggerTypeName
            }

            this.$emit('updateSchedule', data, ['ReportTriggerTypeID', 'ReportTriggerName', 'ReportID', 'ReportTriggerTypeName'])

            delete this.model.ReportTriggerName
            delete this.model.ReportTriggerTypeID

            this.$emit('updateScheduleData', this.model)

            this.$emit('on-update', objToEmit)
        },
        getComponentName (component) {
            const componentTag = component.ComponentTag

            if (componentTag === 'Time') {
                return 'Interval'
            } else if (componentTag === 'Text') {
                return 'InputText'
            } else if (componentTag === 'Number') {
                return 'InputNumber'
            } else {
                return componentTag
            }
        },
        onChange (item) {
            this.model[item.component.ParameterTag] = item.value
        }
    },
    mounted () {
        let counterOfSchedule = 1
        if (this.reportData && this.reportData.ReportTriggerList) {
            counterOfSchedule = this.reportData.ReportTriggerList.filter(el => el.ReportTriggerName.includes(this.$t('report.schedule'))).length
        }
        this.model = {
            ReportTriggerTypeID: this.scheduleData.ReportTriggerTypeID,
            ReportTriggerName: this.scheduleData.ReportTriggerName ? this.scheduleData.ReportTriggerName : `${this.$t('report.schedule')} ${counterOfSchedule + 1}`
        }

        if (this.scheduleData.ScheduleData && Object.keys(this.scheduleData.ScheduleData).length) {
            Object.assign(this.model, this.scheduleData.ScheduleData)
        }
        if (this.reportTriggerTypeList && !Object.keys(this.scheduleData.ScheduleData).length) {
            this.model.ReportTriggerTypeID = this.reportTriggerTypeList[0].ReportTriggerTypeID
        }
    }
}
</script>
<style lang="scss" scoped>
.menu-wrapper {
    @apply z-50 rounded bg-white mt-12 absolute w-40 flex flex-col origin-top-right right-0 shadow-base;
}

.is-expanded {
    transform: rotate(-180deg);
}

.transition {
    transition: all 0.3s ease-out;
}

.active {
    @apply bg-primary text-white border-primary;
}
[dir="rtl"] .trigger-component:not(:last-child) {
    @apply ml-10;
}

[dir="ltr"] .trigger-component:not(:last-child) {
    @apply mr-10;
}
.el-range-editor.is-active, .el-range-editor.is-active {
    @apply border-primary;
}
.report-label {
    @apply mb-3;
}
[dir="rtl"] .report-label {
    @apply ml-3;
}
[dir="ltr"] .report-label {
    @apply mr-3;
}
[dir="rtl"] .trigger {
    @apply ml-10;
}
[dir="ltr"] .trigger {
    @apply mr-10;
}
.interval ::v-deep .el-date-editor.el-input, .interval ::v-deep .el-date-editor.el-input__inner {
    @apply w-32;
}
.content-wrapper {
    @apply flex flex-col;
}
</style>

<style lang="scss">
.trigger-component .el-input, .trigger-component .el-input-number {
    @apply w-32;
}
.time-picker .el-date-editor.el-input__inner {
    @apply w-32;
}

.el-time-range-picker {
    .el-time-panel__footer {
        height: 40px !important;

        .el-time-panel__btn.confirm {
            color: white !important;
            background: var(--primary-color) !important;
            border: 1px solid var(--primary-color) !important;
            border-radius: 4px !important;
            padding-left: 16px !important;
            padding-right: 16px !important;

            &:hover {
                opacity: 0.75 !important;
            }
        }

        .el-time-panel__btn.cancel {
            border: 2px solid var(--gray-550) !important;
            border-radius: 4px !important;
            padding-left: 16px !important;
            font-weight: 700 !important;
            color: var(--gray-550) !important;
            padding-right: 16px !important;

            &:hover {
                background: var(--gray-200) !important;
            }
        }
    }
}
</style>

// <style lang="scss" scoped>
.icon-logo-voicenter {
    width: 800px;
}
</style>
